import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
} from '@mui/material';
import CustomButton from '../../../../../../../../lib/designSystem/Button';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../lib/designSystem/CircularProgress';
import EnhancedTable from '../../../../../../../../lib/designSystem/Table';
import { showAlert } from '../../../../../../../../lib/functions/utils';
import { assignVerifierToOperations } from '../../../../../../../../lib/api/documentConfirmation';
import { cellFormat } from '../../../../../../../../lib/designSystem/Table/cellFormat';

const AssignationDialog = (props: any) => {
  const {
    operationsWithNoVerifier,
    executivesOptions,
    openAssignationDialog,
    setOpenAssignationDialog,
    setUp,
    fetchPortfolio,
  } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [verifier, setVerifier] = useState<string | null>(null);
  const [verifierError, setVerifierError] = useState(false);
  const [businessSelectedForFilter, setBusinessSelectedForFilter] = useState<{
    id: string;
    name: string;
  } | null>(null);

  const handleAssign = async () => {
    if (!verifier) {
      setVerifierError(true);
      return showAlert(dispatch, 'warning', 'Debes seleccionar un verificador');
    }
    if (selectedRequests.length === 0) {
      return showAlert(
        dispatch,
        'warning',
        `Debes seleccionar al menos una solicitud`,
      );
    }
    setLoading(true);
    try {
      const data = {
        verifierId: parseInt(verifier),
        requestIds: selectedRequests,
      };
      await assignVerifierToOperations(dispatch, data);
      showAlert(dispatch, 'success', 'Asignación exitosa');
      setUp();
      fetchPortfolio();
      setOpenAssignationDialog(false);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const headers = [
    { key: 'id', label: 'ID', type: 'numeric-id' },
    { key: 'verifierName', label: 'Verificador' },
    { key: 'businessName', label: 'Cliente' },
    { key: 'amount', label: 'Monto', type: 'money' },
    { key: 'createdAt', label: 'Creado en', type: 'date-large' },
    { key: 'status', label: 'Estado', type: 'status' },
  ];

  const factoringRequestsToAssign = () => {
    if (businessSelectedForFilter) {
      return operationsWithNoVerifier.filter(
        (business: any) => business.id === businessSelectedForFilter.id,
      );
    }
    return operationsWithNoVerifier;
  };

  const filterBusinesses = () => {
    return (
      <Autocomplete
        style={{ width: '300px' }}
        options={operationsWithNoVerifier}
        value={businessSelectedForFilter}
        getOptionLabel={(option: any) =>
          `Solicitud ${cellFormat(option.id, 'numeric-id')} | ${option.businessName} | ${option.businessIdentifier}`
        }
        renderInput={(params) => (
          <TextField
            style={{ minWidth: 100 }}
            {...params}
            label="Filtrar empresas"
          />
        )}
        onChange={(e, value: any) => setBusinessSelectedForFilter(value)}
        fullWidth
      />
    );
  };

  return (
    <Dialog
      open={openAssignationDialog}
      onClose={() => setOpenAssignationDialog(false)}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>Asignación de verificadores a operaciones</DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ minHeight: 200 }}>
            <CenteredCircularProgress type="dialog" />
          </div>
        ) : (
          <>
            <div
              style={{
                padding: '8px 0px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ minWidth: 250 }}>
                <FormControl fullWidth>
                  <InputLabel id={`executive-label`}>Ejecutivo</InputLabel>
                  <Select
                    labelId={`executive-label`}
                    label="Ejecutivo"
                    id={`executive-select`}
                    fullWidth
                    error={verifierError}
                    value={verifier}
                    onChange={(e) => {
                      setVerifier(e.target.value);
                      setVerifierError(false);
                    }}
                  >
                    {executivesOptions.map((option: any) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div>{filterBusinesses()}</div>
            </div>
            <EnhancedTable
              data={factoringRequestsToAssign()}
              dataHeaders={headers}
              selected={selectedRequests}
              setSelected={setSelectedRequests}
              canSelectAll
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          color={'secondary'}
          onClick={() => setOpenAssignationDialog(false)}
          disabled={loading}
        >
          Salir
        </CustomButton>
        <CustomButton
          color={'primary'}
          onClick={handleAssign}
          disabled={loading || selectedRequests.length === 0}
        >
          Asignar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default AssignationDialog;
